import { toJSON } from "../utils";
export class AirdropConfig {
    //   TODO randomize options
    constructor(params) {
        this.network = params.network;
        this.contractId = params.contractId;
        this.contractAddress = params.contractAddress;
        this.metadataTemplateId = params.metadataTemplateId;
        this.metadataTemplateName = params.metadataTemplateName;
    }
    get json() {
        return toJSON(this);
    }
}
